import { LazyQueryResultTuple, useLazyQuery } from '@apollo/client';
import { ROD_REQUEST_CADDIES } from '@bechtel/client-gql';
import { RodRequestCaddyList } from '@bechtel/types';

export function useRodRequestCaddies(
  fetchFromNetwork?: boolean
): LazyQueryResultTuple<{ rodRequestCaddies: RodRequestCaddyList }, Record<string, any>> {
  const response = useLazyQuery<{
    rodRequestCaddies: RodRequestCaddyList;
  }>(
    ROD_REQUEST_CADDIES,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
